import { GoogleAuthProvider } from "firebase/auth";

export const PROVIDERS = {
  google: new GoogleAuthProvider()
}